import { ChangeEventHandler } from 'react';

import { InputSearch } from '@/domains/core/tamagoshiTailwind/components/Input/InputSearch';

import { searchInputLabel } from './translations';

interface FilterSearchBarProps {
  onBlur?: () => void;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: () => void;
  onResetValue?: () => void;
  value?: string;
}

export const FilterSearchBar = ({
  onBlur,
  onChange,
  onFocus,
  onResetValue,
  value,
}: FilterSearchBarProps) => (
  <div className="mb-m">
    <InputSearch
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onReset={onResetValue}
      label={searchInputLabel}
      value={value}
    />
  </div>
);
